import React, { Component } from 'react';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import { colorPalette } from 'styles'
import Tooltip from '@material-ui/core/Tooltip'
import moment from 'moment'

export class NotificationItem extends Component {

  handleClick = event => {
    event.stopPropagation()
    this.props.onClick && this.props.onClick()
  }

  handleToggleRead = event => {
    event.stopPropagation()
    this.props.onToggleRead && this.props.onToggleRead()
  }

  get timeAgo(){
    return moment.duration(moment().diff(moment(this.props.notification.createdAt))).humanize()+ ' ago'
  }

  render = () =>
    <ListItem component="li" button onClick={this.handleClick} className={this.props.className}>
      <ListItemIcon onClick={this.handleToggleRead}>
      <Tooltip style={{margin: 0}} title={`Mark as ${this.props.notification.read ? 'unread' : 'read'}`}  placement="bottom-end">
        <div style={{
          width: 10,
          minWidth: 10,
          height: 10,
          borderRadius: 50,
          background: this.props.notification.read ? colorPalette.secondary[2].hex() : colorPalette.primary[0].hex()
        }}/>
      </Tooltip>
      </ListItemIcon>
      <ListItemText
        primary={this.props.notification.title}
        secondary={<span className='list-item-secondary'>{this.timeAgo}</span>}
      />
    </ListItem>
}

export default NotificationItem
